import { medialUrl } from "../../EndPoints";
import RedTriangleStroke from "../../assets/images/products/sweater/triangle-stroke.png";

export const heroQAbg = `${medialUrl}/img/QA/QAbg.jpg`;
export const triangleDecoQA = RedTriangleStroke;
